import { render, staticRenderFns } from "./videoinfocard.vue?vue&type=template&id=10180247&scoped=true&"
import script from "./videoinfocard.vue?vue&type=script&lang=js&"
export * from "./videoinfocard.vue?vue&type=script&lang=js&"
import style0 from "./videoinfocard.vue?vue&type=style&index=0&id=10180247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10180247",
  null
  
)

export default component.exports